import { queryParamsToApiParams } from "../../utils";

const CROSS_TAB_SEARCH_COUNT_QUERY_PARAM_KEYS_TO_OMIT = new Set([
  "overall_status",
  "report_result",
  "client_decision",
  "page",
  "page_size",
  "ordering",
]);

export function queryParamsToCrossTabSearchCountApiParams(
  params: Record<string, string | undefined>
) {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(
      ([key, value]) =>
        value !== undefined &&
        !CROSS_TAB_SEARCH_COUNT_QUERY_PARAM_KEYS_TO_OMIT.has(key)
    )
  ) as Record<string, string>;

  return queryParamsToApiParams(filteredParams);
}
